import axios from 'axios'
import authenticationStore from '../stores/authenticationStore'
import utils from '../utils'
import { apiUrl, apiConvertOfficeUrl } from '../config'

export const convertAnyToBlob = {
  async getBlobPdfFormatOfOfficeFileV2(fileId, fileName) {
    try {
      // Step 1: Fetch the DOCX file from your API using axios
      const response = await axios.get(
        `${apiUrl}/api/v1/upload/attachments/${fileId}`,
        {
          responseType: 'blob', // This ensures the file is downloaded in binary format
          headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: `Bearer ${
              JSON.parse(authenticationStore.appToken).access_token
            }`, // Replace with your actual token
          },
        }
      )
      let extOfFile = utils.getExtensionFile(fileName)
      const acceptWordFiel = ['doc', 'docx']
      const acceptExcelFile = ['csv', 'xls', 'xlsb', 'xlsx', 'xltx']
      let convertUrl = `${apiConvertOfficeUrl}/api/converter/to-pdf-blob`
      let docFormatType = ''
      if (acceptWordFiel.includes(extOfFile)) {
        docFormatType =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      } else if (acceptExcelFile.includes(extOfFile)) {
        docFormatType =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
      const file = new File([response.data], `${fileName}`, {
        type: docFormatType,
      })
      const formData = new FormData()
      formData.append('sourceFile', file)
      formData.append('fileName', fileName)
      formData.append('extOfFile', extOfFile)
      formData.append('fileId', fileId)

      try {
        const convertResponseBlob = await axios.post(convertUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'blob',
        })
        const fileBlob = convertResponseBlob.data
        return URL.createObjectURL(fileBlob)
      } catch (error) {
        // console.error('Error during conversion:', error)
      }
    } catch (error) {
      // console.error('Error converting DOCX to PDF:', error)
      throw error // Re-throw the error so the caller knows something went wrong
    }
  },
}
